import { useState, useEffect, useMemo } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import TableData from "./Component/Table/TableData";
import { connect } from "react-redux";
// icn
import { ReactComponent as DocVector } from "../../../../Assets/Images/icn/docVector.svg";
import { ReactComponent as DocUpload } from "../../../../Assets/Images/icn/UploadDoc.svg";
import UploadDoc from "./Component/Modal/UploadDoc";
//import
import { addDocumentData, getDocumentList } from "store/services/documentsService";
import * as actions from "store/actions";
import { convertBytes, storageUtilizationValidations } from "helpers/common";
import { SUCCESS_MESSAGE } from "common/constantMessage";
import { getStorageInfo } from "store/services/documentStorgeService";
import StorageExhaustedPopup from "components/shared/StorageExhaustedPopup";
import { uploadFilePresignedUrl } from "store/services/fileService";
import AppTooltip from "components/shared/CommonTooltip";
import StorageWarningPopup, { useShowWarningPopup } from "components/shared/StorageWarningPopup";

const MyDocs = ({ dispatch }) => {
  const [UploadDocPop, setUploadDocPop] = useState();

  // storage information
  const [storageDetails, setStorageDetails] = useState(null);

  // storage exhausted popup state
  const [showStorageExhaustedPopup, setshowStorageExhaustedPopup] = useState(false);

  // storage about to exhaust popup state
  const [showStorageWarningPopup, openStorageWarningPopup, closeStorageWarningPopup] = useShowWarningPopup();

  const { isStorageExhausted, isStorageAboutToExhaust } = useMemo(() => {
    return storageUtilizationValidations(storageDetails);
  }, [storageDetails]);

  useEffect(() => {
    getStorageInfoData();
  }, [])

  const handleUploadDoc = () => setUploadDocPop(!UploadDocPop);

  //get data
  async function getData() {
    try {
      let filter = {};
      dispatch(actions.persist_store({ loader: true }));
      await dispatch(getDocumentList(filter));
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }

  const submitData_ = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true);
      dispatch(actions.persist_store({ loader: true }));
      let uploadedFileResult = null;
      if (values.file) {
        const payload = {
          file: values.file,
          values: {
            fileName: values?.file_name,
            extension: values?.extension,
            folder: "documents",
          }
        }
        uploadedFileResult = await uploadFilePresignedUrl(payload);
      }

      const fileSizeInBytes = values?.file?.size;
      const fileSizeInMB = convertBytes(fileSizeInBytes, "mb");
      const fileUrl = uploadedFileResult?.public_url || uploadedFileResult?.fileUrl;
      if (fileUrl) {
        let postData = {
          name: values?.file?.name,
          url: fileUrl,
          size: fileSizeInMB,
          size_bytes: fileSizeInBytes
        }
        let response = await dispatch(addDocumentData(postData));
        if (response.success === true && response.message) {
          setUploadDocPop(false);
          SUCCESS_MESSAGE(response.message)
        }
        getStorageInfoData();
        await getData();
      }
      setSubmitting(false);
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log(err, "==============================");
      setSubmitting(false);
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  const getStorageInfoData = async () => {
    try {
      dispatch(actions.persist_store({ loader: true }));
      let response = await getStorageInfo();
      if (response?.success) {
        setStorageDetails(response?.body);
      }
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.error("Error fetching storage details", err);
    }
  };

  const openStorageExhaustedPopup = () => {
    setshowStorageExhaustedPopup(true);
  };

  const closeStorageExhaustedPopup = () => {
    setshowStorageExhaustedPopup(false);
  };

  return (
    <>
      <UploadDoc
        UploadDocPop={UploadDocPop}
        setUploadDocPop={setUploadDocPop}
        submitData_={submitData_}
        storageDetails={storageDetails}
      />
      <StorageExhaustedPopup
        showPopup={showStorageExhaustedPopup}
        handleClose={closeStorageExhaustedPopup}
      />
      <StorageWarningPopup
        showPopup={showStorageWarningPopup}
        handleClose={closeStorageWarningPopup}
      />
      <section className="DocsForms position-relative">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div
                className="commonCardBox d-flex border-0 align-items-start justify-content-between gap-10 p-lg-4 p-3 ps-lg-5 pe-3 DocFormBox"
                style={{
                  background:
                    "linear-gradient(90deg, rgba(241,141,6,1) 6%, rgba(254,250,224,1) 57%, rgba(255,254,247,1) 100%)",
                }}
              >
                <div className="left d-flex align-items-start gap-10 ">
                  <div className="imgWrp me-2">
                    <DocVector />
                  </div>
                  <div className="content">
                    <h6 className="fw-bold m-0 capitalize">Documents</h6>
                    <p className="m-0 py-1">
                      Upload and provide your clients with easy links to your
                      all your documents and files. All URLs are publicly
                      available so do not include any client specific personal
                      information or data in documents that you upload. All file
                      types are accepted.
                    </p>
                  </div>
                </div>
                <div className="right">
                  <div className="d-flex gap-10 align-items-center">
                    <Button
                      onClick={isStorageExhausted ? openStorageExhaustedPopup : handleUploadDoc}
                      className="d-flex  align-items-center justify-content-center commonBtn btnSm"
                    >
                      <span className="icn me-2">
                        <DocUpload />
                      </span>
                      Upload new docs
                    </Button>
                    {isStorageAboutToExhaust && (
                      <Button
                        onClick={openStorageWarningPopup}
                        variant="transparent"
                        className="border-0 p-0"
                      >
                        <AppTooltip text="Storage space is running low" placement="top">
                          <span className="icn p-2">
                            <i style={{ fontSize: 16 }} className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                          </span>
                        </AppTooltip>
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="commonCardBox">
                <TableData />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
const mapStateToPros = (state) => {
  // console.log("state", state);
  return {
    loader: state.Documents.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(MyDocs);
